import { Box, SvgIcon } from '@mui/material';
import { useRecordContext, FieldProps } from 'react-admin';
import { inventoryCategoryIconMap, InventoryCategoryIconName } from '../icons/inventoryCategoryIcons';

export const IconField = (props: FieldProps & { iconName?: InventoryCategoryIconName }) => {

  const record = useRecordContext(props);

  let Icon: typeof SvgIcon;
  if (props.iconName) {

    Icon = inventoryCategoryIconMap[props.iconName];

  } else {

    const icon = record?.[props.source];
    if (!icon) return null;

    Icon = inventoryCategoryIconMap[icon as InventoryCategoryIconName];

  }
  if (!Icon) return null;

  return (
    <Box display="flex" alignItems="center">
      <Icon fontSize="small" />
    </Box>
  );

};
